import { render } from "./BlogAllxAll6OrAll4.vue?vue&type=template&id=27f2c845"
import script from "./BlogAllxAll6OrAll4.vue?vue&type=script&lang=js"
export * from "./BlogAllxAll6OrAll4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__